import { useMutation } from 'react-query';
import { MutationConfig, queryClient } from 'src/lib/react-query';
import useNotification from 'src/store/Notifications/useNotification';
import { axiosDefaultApi } from 'src/lib/axios';


const mapPlaceToApiPlaceDto = (values: IEditModelForm): IPostEditModel | {} => {
  let dataMapping: IPostEditModel | {} = {};

    dataMapping = {
      deleted: values.deleted,
      module: values.module,
      modelTypeID: +values.modelTypeID,
      description: values.description, 

    }
  
  return dataMapping;
}

const editModel = ( {data, modelId} : {data: IEditModelForm , modelId: number}): Promise<string> => {
  const model = mapPlaceToApiPlaceDto(data)
  return axiosDefaultApi.put(`/api/Models/UpdateModel/${modelId}`, model);
};

type QueryFnType = typeof editModel;

type UseEditModelOptions = {
  data: IEditModelForm | {};
  modelId: number;
  config?: MutationConfig<QueryFnType>;
};

export const useEditModel = ({ config }: UseEditModelOptions) => { 
    const {addNotification, setIsNotificationVisible} = useNotification();
    return useMutation({
        onError: (error: any) => {
            addNotification(`Υπήρξε κάποιο πρόβλημα στην επεξεργασία του Τύποι Συσκευής.`, 500);
            console.error('Couldnt edit Model', error);
            setIsNotificationVisible(true)
          },
          onSuccess: () => {
            queryClient.invalidateQueries(["getAllModels"])
            addNotification('Ο Τύπος Συσκευής Ενημερώθηκε.', 200);
            setIsNotificationVisible(true)
          },
        ...config,
        mutationFn: editModel,
    })
}